var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUAQMAAADFiO34AAAABlBMVEX/////AP/GWAgeAAAAEElEQVR4AWMgETD+x0KSAQD4fAQB5GgvMQAAAABJRU5ErkJggg==";
  export default img;